"use client";

import React from "react";

type TabType = "sales" | "customers" | "review";

interface DashboardTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

const TABS: { key: TabType; label: string }[] = [
  { key: "sales", label: "Sales" },
  { key: "customers", label: "Customers" },
  { key: "review", label: "Review" },
];

export const DashboardTabs: React.FC<DashboardTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  const activeIndex = TABS.findIndex((tab) => tab.key === activeTab);

  const getTransform = () => {
    if (activeIndex <= 0) return "translateX(0)";
    const gapOffset = activeIndex * 0.25;
    return `translateX(calc(${activeIndex * 100}% + ${gapOffset}rem))`;
  };

  return (
    <div className="relative bg-gray-100 rounded-lg w-full mt-4 p-1 select-none flex gap-x-2">
      <div
        className="absolute top-1 left-1 h-[calc(100%-0.5rem)] rounded-lg bg-white shadow transition-transform duration-300 ease-in-out z-0"
        style={{
          pointerEvents: "none",
          width: `calc((100% - 1rem) / ${TABS.length})`,
          transform: getTransform(),
        }}
      />

      {TABS.map((tab) => (
        <button
          className={`relative flex-1 px-4 py-2 text-sm font-medium rounded-lg transition-colors text-center
            ${
              activeTab === tab.key
                ? "text-black cursor-default"
                : "text-gray-500 hover:bg-gray-200 cursor-pointer"
            }`}
          disabled={activeTab === tab.key}
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          type="button"
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};
